import { render, staticRenderFns } from "./LeaguePage.vue?vue&type=template&id=3371f05e&"
import script from "./LeaguePage.vue?vue&type=script&lang=js&"
export * from "./LeaguePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports